import React from "react";

const Home = () => {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="font-extrabold text-3xl">PROTECTED DATA</div>
      </div>
    );
};

export default Home